import { render, staticRenderFns } from "./GroupCompanySettingsTable.vue?vue&type=template&id=4a927eca"
import script from "./GroupCompanySettingsTable.vue?vue&type=script&lang=js"
export * from "./GroupCompanySettingsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports